function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4 10v8a2 2 0 002 2h12a2 2 0 002-2v-8H4zM0 6a6 6 0 016-6h12a6 6 0 016 6v12a6 6 0 01-6 6H6a6 6 0 01-6-6V6z"
});

function SvgDatetime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgDatetime;